<template>
  <div class="home">
    <img src="../assets/images/mb_bg.png" class="w-full max-w-[600px] mx-auto" alt="">
    <img src="../assets/images/arrow.png"  class="shake-element -mt-10 mx-auto " width="35" alt="">
    <div class="flex items-center justify-center pt-4 col flex-col md:flex-row">
      <!-- <img src="../assets/images/btn_1.png"  class="cursor-pointer mb-2 mb:mt-0 max-w-[220px] w-1/2 md:mr-3" @click="getTicket('dailyget', 1)" alt=""> -->
      <img src="../assets/images/btn_2.png" class="cursor-pointer mb-2 w-1/2 max-w-[220px] md:mr-3" alt="" @click="buyTicketModel = true, tickets = 0, error = ''" >
      <img src="../assets/images/btn_3.png" @click="scrollToTarget"  class="cursor-pointer mb-2 max-w-[220px] w-1/2" alt="">
    </div>
    <div class="p-3 max-w-[600px] md:mx-auto">
      <div class="mt-3 grid grid-cols-2 gap-2" ref="targetElement">
        <!-- :class="{'col-span-2 mx-auto': index === 0,'w-[70%]': index === 0}" -->
        <div class="bg-white p-1 box-item" v-for="(item, index) in rewardList" :key="index" >
          <div class="w-full">
            <img :src="`https://csai.uupon.com/img/reward_${item.id}.png`" class="w-full" alt="">
            <!-- <img :src="require(`../assets/images/reward_1.jpg`)" class="w-full md:hidden" alt=""> -->
            <!-- <img :src="require(`../assets/images/reward_pc_1.jpg`)" class="w-full hidden md:block" alt=""> -->
            <p class="my-2 text-center font-bold">{{ item.box_name }}</p>
          </div>
          <div class="w-full">
            <div class="md:flex justify-around">
              <div class="flex items-center justify-between text-sm text-[#868686]">
                <p>您已投入的張數 </p>
                <p class="ml-1">{{ item.mycount || 0 }}<span class="ml-1">張</span></p>
              </div>
              <div class="flex items-center justify-between text-sm text-[#868686]">
                <p>目前投入總張數 </p>
                <p class="ml-1">{{ item.total_count }}<span class="ml-1">張</span></p>
              </div>
            </div>
            <div class="w-full cursor-pointer mt-3 bg-[#0b53d3] py-1 text-white font-bold md:text-lg" @click="boxId = item.id, showModel = true">投入抽獎券</div>
            <!-- <img src="../assets/images/box_btn.png" @click="boxId = item.id, showModel = true" class="cursor-pointer md:hidden w-full mt-3" alt=""> -->
            <!-- <img src="../assets/images/box_btn_pc.png" @click="boxId = item.id, showModel = true" class="cursor-pointer hidden md:block w-full mt-3" alt=""> -->
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/images/btn_side.png" @click="showNoticeModel = true" width="10%" class="cursor-pointer max-w-14 fixed right-0 bottom-10" alt="">
    <div class="modal" v-if="showModel || buyTicketModel || msgModel">
      <div class="modal-content shadow p-5 text-[#868686]" v-if="showModel">
        <p class="my-3">您確定要兌換嗎?</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-2 w-1/3 mr-3 cursor-pointer" @click="showModel = false">取消</button>
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="box()">確認</button>
        </div>
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="buyTicketModel">
        <div class="my-3 flex items-center justify-between w-3/4 mx-auto">
          <p class="">您現有的點數為: </p><p>{{ points }} 點</p>
        </div>
        <div class="my-3 flex items-center justify-between w-3/4 mx-auto">
          <p class="">目前剩餘抽獎券: </p><p>{{ lastTickets }} 張</p>
        </div>
        <div class="my-3 flex items-center justify-between w-3/4 mx-auto">
          <p class="">您可購買的上限為: </p><p>{{ parseInt(points / 10) }} 張</p>
        </div>
        <p class="my-3 text-red-500">*10點可換1張抽獎券</p>
        <!-- <p class="my-3">目前剩餘抽獎券: {{ lastTickets }} 張</p>
        <p class="my-3">您可購買的上限為: {{ parseInt(points / 10) }} 張</p>
        <p class="my-3 text-red-500">*10點可換1張抽獎券</p> -->
        <div class="my-3 flex items-center justify-between w-3/4 mx-auto">
          <p class="">請輸入購買張數:</p>
          <div>
            <input type="number"  min="1" v-model="tickets" class="text-sm w-20 border text-right mx-1 rounded-lg outline-2 outline-blue-500/50 px-1">張
          </div>
        </div>
        <!-- <div class="my-3 flex items-center justify-center">請輸入購買張數:<input type="number"  min="1" v-model="tickets" class="text-sm w-20 border text-right mx-1 rounded-lg outline-2 outline-blue-500/50 px-1">張</div> -->
        <p v-if="error !== ''" class="text-xs text-red-500 my-2">{{ error }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-zinc-400 py-2 w-1/3 mr-3 cursor-pointer" @click="buyTicketModel = false">取消</button>
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="getTicket('add', tickets)">確認</button>
        </div>
      </div>
      <div class="modal-content shadow p-5 text-[#868686]" v-if="msgModel">
        <p class="my-3">{{ msgCode === ''? '': `[${msgCode}]` }}{{ msg }}</p>
        <div class="flex items-center justify-center text-white">
          <button class="rounded-full bg-[#fcc02e]  py-2 w-1/3 cursor-pointer" @click="closeMsgModel()">確認</button>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showNoticeModel">
      <div class="relative max-w-[900px]">
        <img src="../assets/images/btn_close.png" @click="showNoticeModel = false" class="z-20 absolute right-5 -top-10 max-w-[50px] cursor-pointer" width="35px" alt="">
        <!-- <img class="relative translate-y-2/4 m-auto  z-50 max-w-[400px]" src="../assets/images/title.png" width="70%" alt=""> -->
        <!-- <div class="relative translate-y-2/4 m-auto rounded-sm  bg-[#06133d] py-2 text-lg text-nowrap w-[70%] text-white font-bold z-50 max-w-[400px]">
          第015期抽獎趣活動說明
        </div> -->
        <div class="relative notice max-h-[60vh] w-[90%] mx-auto overflow-y-auto bg-white">
          <div class="text-left pt-10 pb-6 px-3 md:px-10 text-sm text-[#868686]">
            <p>一、凡參加兌換抽獎券者，視為同意下列事項及主辦單位活動辦法：</p>
            <br>
            <ul>
              <li>1.參加者須加入「程曦_企業AI數位培訓」LINE官方帳號好友，並完成「課程報名」獲得i點數，始得參加「程曦_企業AI數位培訓 」抽獎券兌換活動（以下簡稱本活動）。</li>
              <li>2.參加者於參加本活動同時，即同意接受本活動各式活動辦法規範，如有違反，程曦資訊整合股份有限公司（以下簡稱本公司）得取消參加資格，並得就因此所產生之損害，向該參加者請求損害賠償。</li>
              <li>3.本次活動由點鑽整合行銷股份有限公司(以下簡稱UUPON)提供獎項禮品，獎項使用依遵守UUPON點數與電子票券使用規則為主。</li>
              <li>4.本公司保留隨時修正、暫停、終止或解釋本活動之最終權利（包括但不限於更換活動、提前終止或延長活動時間之最終決定權等事項），並以本活動公告為準。</li>
              <li>5.參加本活動獲得點數可兌換抽獎券，抽獎時間為4期，每期每個抽獎箱依規劃抽出不同名額，期數如下：</li>
              <ul>
                <li>第1期：2025年  1/1-3/31  23:59分投進抽獎箱，抽獎公告日：4/9 </li>
                <li>第2期：2025年  4/1-6/30  23:59分投進抽獎箱，抽獎公告日：7/9</li>
                <li>第3期：2025年  7/1-9/30  23:59分投進抽獎箱，抽獎公告日：10/8</li>
                <li>第4期：2025年  10/1-12/3123:59分投進抽獎箱，抽獎公告日：2026/1/</li>
                <li>每期得獎名單會公告於 「程曦_企業AI數位培訓」官方LINE OA、UUPON官網(https://uupon.tw/)或UUPON臉書，中獎者請於收到簡訊通知後15日內下載註冊UUPON APP，本活動將於簡訊發送後30日內派發UUPON點數與UUPON電子票券至您的UUPON帳戶中。UUPON點數請於UUPON點數存摺查詢，電子票券請於UUPON兌換券專區查詢。獲獎領取期限為2025年12月31日止，請於期限內下載與註冊UUPON帳號，逾期則取消抽獎點數與電子票券領取資格。</li>
              </ul>
              <li>6. 凡持有本活動i點會員即可參加抽獎活動，每次投入抽獎券不限張數。</li>
              <li>7. 本活動圖片僅供參考，獎品以本活動提供之獎項為準，不得要求兌換等值的商品或現金。</li>
              <li>8. 若因用戶網路狀況、裝置差異、手機設定、移轉帳號或其他變更等因素導致無法順利完成活動或獲得 之獎項遗失,本公司將不負擔任何責任或損害賠償。</li>
              <li>9. 獲取獎項之使用者必須遵守 UUPON APP 使用條款、活動規則及注意事項,如有違反視同放棄，UUPON 擁有取消其兌換資格之權利。</li>
              <li>10. UUPON 點數一經扣點進行兌換商品或票券後，視同交易完成，即不接受取消交易或返還點數。</li>
              <li>11. 獎項不得兌現、分割、出售或轉售。</li>
              <li>12. 得獎者不得要求獎項折算現金或轉讓，中獎者個人資料需與「程曦_企業AI數位培訓」與 「UUPON 會員資料」會員帳戶資料一致，如經查證非同一人將取消中獎資格。</li>
              <li>13. 參與本活動前請詳閱注意事項以維護您的權益，本活動保有活動變更、取消以及最終解釋等所有權。</li>
              <li>14. 如有未盡事宜，悉依相關規定或解釋，本公司得隨時補充公告說明，並保有本次活動最終解釋權。</li>
            </ul>
            <br>
            <p>二、抽獎獎項及領獎注意事項：</p>
            <br>
            <ul>
              <li>1.每一期獎項說明 :</li>
              <ul>
                <li>(1)UUPON點數5000點：3名</li>
                <li>(2)UUPON點數3000點：4名</li>
                <li>(3)UUPON點數2000點：6名</li>
                <li>(4)UUPON點數1000點：9名</li>
                <li>(5)統一集團通用 100元 7-ELEVEN數位商品禮券 喜客券：10名</li>
                <li>(6)家樂福100元即享券：10名</li>
                <li>(7)屈臣氏即享券100元(餘額型)：10名</li>
              </ul>
              <li>2.獎品價值超過新台幣 1,000 元(含)以上者，將寄發中獎通知函;中獎者請務必收到簡訊通知後完善會員個人資料(姓名、電話、地址、Email)並且需正確無誤(姓名及地址需與身 分證一致)，因資料不完善，致使本活動人員無法聯繫，將視同放棄中獎資格。</li>
              <li>3.中獎金額或獎品價值超過新台幣 1,000 元(含)以上者，需先繳交身分證正反面影本供報稅使用，始可領獎，年度報稅時將併入個人綜合所得稅申報。</li>
              <li>4.本公司保留隨時修正、暫停、終止或解釋本活動之最終權利（包括但不限於更換活動、提前終止或延長活動時間之最終決定權等事項），並以本活動公告為準。</li>
              <li>5.得獎者若為未成年人則不符合此活動資格。視為無效中獎名單。</li>
              <li>6.若得獎者不願先行繳納本項依稅法規定須先扣繳之稅金，或未依上述說明辦理領獎手續(含逾期未 領取獎項)，視同放棄中獎資格，且不得異議。</li>
            </ul>
          </div>
          <!-- <img src="../assets/images/triangle.svg" width="40%" class="md:hidden" alt=""> -->
          <!-- <img src="../assets/images/triangle_pc.svg" width="40%" class="hidden md:block" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import axios from 'axios'
import CryptoJS from 'crypto-js'
import axios from 'axios'
import liff from '@line/liff'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      encryptedString: '',
      key: '5334023153340231',
      decryptedWord: null,
      encryptedBase64: '',
      decryptedData: null,
      rewardList: [],
      showModel: false,
      showNoticeModel: false,
      buyTicketModel: false,
      kn: '',
      openId: '',
      points: 0,
      tickets: 0,
      msgModel: false,
      msg: '',
      msgCode: '',
      goToIndex: false,
      error: '',
      boxId: '',
      lastTickets: 0,
      profile: {},
      loginStatus: ''
    }
  },
  async created () {
    this.profile.userId = localStorage.getItem('userId') || ''
    this.profile.displayName = localStorage.getItem('displayName') || ''
  },
  async mounted () {
    this.getInf()
    // try {
    //   await liff.init({ liffId: '1661400637-Gvq3v5rd' })
    //   if (liff.isLoggedIn()) {
    //     this.profile = await liff.getProfile()
    //     this.getInf()
    //   } else {
    //     liff.login()
    //   }
    // } catch (error) {
    //   console.error('LIFF 初始化失敗:', error)
    // }
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    goToExchange () {
      this.$router.push({ name: 'exchange' })
    },
    async getInf () {
      await axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/LineInfo?lineid=${this.profile.userId}`
      }).then((response) => {
        this.inf = response.data
        this.decryptData(this.inf)
        if (this.decryptedData) {
          if (this.decryptedData.code === '100' && this.decryptedData.openId !== '') {
            this.points = this.decryptedData.points
            this.openId = this.decryptedData.openId
          } else {
            this.$router.replace({ name: 'bind', query: { source: 'box' } })
          }
          const newArray = { openId: this.openId }
          this.encryptData(newArray)
          this.getList()
        } else {
          alert('資料錯誤')
          liff.closeWindow()
        }
        this.getList()
      })
    },
    // 解密
    decryptData (data) {
      try {
        const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
        const encryptedWordArray = CryptoJS.enc.Base64.parse(data)
        // 使用 AES-128-ECB 解密
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encryptedWordArray },
          keyWordArray,
          { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        )
        this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
      } catch (error) {
        this.decryptedData = null
      }
    },
    // 加密
    encryptData (data) {
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.encryptedBase64 = encryptedBase64
    },
    getTicket (act, tickets) {
      if (act === 'add' && tickets > parseInt(this.points / 10)) {
        this.error = '*超過可購買數量，請重新輸入'
        return
      } else if (act === 'add' && tickets === 0) {
        this.error = '*請先輸入購買數量'
        return
      } else {
        this.error = ''
      }
      const data = {
        openId: this.openId,
        act: act,
        tickets: act === 'add' ? tickets : 1
      }
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const inf = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      this.decryptData(inf)
      axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/GetTicket?inf=${inf}`
      }).then((response) => {
        this.msg = response.data.errno
        this.buyTicketModel = false
        this.msgModel = true
        this.lastTickets = Number(response.data.tickets)
        if (act === 'add') {
          this.points = response.data.aiPool
        }
        this.goToIndex = Boolean(response.data.code === 2000)
      })
    },
    closeMsgModel () {
      if (this.msgCode !== '') {
        liff.closeWindow()
      } else {
        this.msgModel = false
      }
    },
    box () {
      const data = {
        openId: this.openId,
        box_id: this.boxId
      }
      const jsonString = JSON.stringify(data)
      const keyWordArray = CryptoJS.enc.Utf8.parse(this.key)
      const encrypted = CryptoJS.AES.encrypt(jsonString, keyWordArray, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      })
      const inf = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      fetch(`https://csaiapi.uupon.com/PutTicket?inf=${inf}`, {
        method: 'POST'
      }).then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      }).then(data => {
        this.msg = data.msg
        this.showModel = false
        this.msgModel = true
        this.getList()
      }).catch(error => {
        console.error(error)
      })
    },
    async getList () {
      // 有帶inf時取得會員投票的紀錄
      await axios({
        method: 'get',
        url: 'https://csaiapi.uupon.com/BoxList'
      }).then((response) => {
        this.rewardList = response.data.filter(v => v.state === '0')
      })
      axios({
        method: 'get',
        url: `https://csaiapi.uupon.com/BoxList?inf=${this.encryptedBase64}`
      }).then((response) => {
        if (response.data.length > 0) {
          if (response.data[0].kaiin_no !== '' || response.data.length === 0) {
            this.userList = response.data
            for (let i = 0; i < this.rewardList.length; i++) {
              for (let j = 0; j < this.userList.length; j++) {
                if (this.userList[j].id === this.rewardList[i].id) {
                  this.rewardList[i].mycount = this.userList[j].mycount
                }
              }
            }
          }
        }
        // this.rewardList = response
      })
    },
    scrollToTarget () {
      const targetElement = this.$refs.targetElement
      targetElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  font-family: 'Inter', sans-serif;
}
.home{
  min-height: 100vh;
  background-color: #06133d !important;
  // background-image: url('../assets/images/bg_mb.jpg');
  // background-repeat: no-repeat;
  // background-position: top;
  // background-size: contain;
  width: 100%;
  .box-item{
    // background-image: url('../assets/images/box_bg.png') ;
    background-position: left bottom;
    background-size: 90%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-content{
      max-width: 450px;
      background: #ffffff;
      width: 90%;
      border-radius: 12px;
      margin: auto;
    }
    .notice{
      border: 2px solid #06133d;
    }
  }
}
@media only screen and (min-width: 768px) {
  .home{
    background-color: #06133d !important;
    // background-repeat: no-repeat !important;
    // background-position: 0px 350px !important;
    // background-size: contain !important;
    // background: url('../assets/images/bg_pc.jpg');
    width: 100%;
    .box-item{
      // background-image: url('../assets/images/box_bg_pc.png') ;
      // background-size: 70%;
    }
    .modal{
      .notice{
        border: 4px solid #06133d;
      }
    }
  }
}
</style>
